import {
    createRouter,
    createWebHashHistory,
    createWebHistory,
    RouteRecordRaw,
} from "vue-router";
import HomeView from "../views/home/homeIndex.vue";
import { routesMobile } from "./module/mobile";
import { routesWeb } from "./module/web";
import { routesTest } from "./module/test";
import systemTools from "@/utils/platform";
import { LOGIN_TOKEN_KEY } from "@/constant";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Home",
        component: HomeView,
        meta: {
            level: 1,
        },
    },
    ...routesWeb,
    ...routesMobile,
    ...routesTest,
];

//console.log("process.env=====", process.env);
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), //createWebHashHistory
    routes,
    scrollBehavior(to, from, savedPosition) {
        //console.log("11111111111111", to, from, savedPosition);
        if (savedPosition) {
            return savedPosition;
        }else{
            if(to.name === "Post" || to.name === "PostDetail"){
                return 
            }else{
                return { top: 0, behavior: "smooth" };
            }
        }
    },
});

// 设置全局前置守卫
router.beforeEach((to, from, next) => {
    const isMobile = window.innerWidth <= 774 && systemTools.isMobile();
    const isMobileNewPath = /mobile/gi.test(to.path);
    // console.log(
    //     "isMobile:::::::::::::::::",
    //     isMobile,
    //     isMobileNewPath,
    //     to.path,
    //     from.path
    // );
    const isMobilePath = isMobileNewPath && isMobile;
    if (isMobilePath) {
        const token = localStorage.getItem(LOGIN_TOKEN_KEY) as string;
        //console.log("isLogined:::::::::::::::::", token, to.path);
        if (!token && to.path !== "/mobile/login") {
            next("/mobile/login");
        } else {
            next();
        }
    } else {
        next();
    }
    // if (isMobile) {
    //     const token = localStorage.getItem(LOGIN_TOKEN_KEY) as string;
    //     // console.log("isLogined:::::::::::::::::", token, to.path, from.path);
    //     if (to.path === "/") {
    //         if (!token) {
    //             //next("/mobile/login");
    //             next("/mobile");
    //         } else {
    //             next("/mobile");
    //         }
    //     } else {
    //         next();
    //         // if (!token && to.path !== "/mobile/login") {
    //         //     //next("/mobile/login");
    //         //     next();
    //         // } else {
    //         //     next();
    //         // }
    //     }
    // } else {
    //     next();
    // }
});

export default router;
